// ================================
// REAVERFIT — SIZE BAND JAVASCRIPT
// ================================

// Bandeau tailles : add-to-cart AJAX + protection contre le clic de la carte
(function () {
  // Empêche le clic de la carte quand on clique une taille
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.rf-size--available');
    if (!btn) return;
    e.stopPropagation();
    e.preventDefault();

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    // Add to cart via AJAX
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(r => r.json())
      .then(() => {
        // Dispatch un event pour les thèmes/apps
        document.dispatchEvent(new CustomEvent('rf:cart:added', {
          detail: { variantId: Number(variantId) }
        }));
        // Toast local
        const band = btn.closest('[data-rf-size-band]');
        const toast = band && band.querySelector('.rf-size-band__toast');
        if (toast) {
          toast.textContent = 'Ajouté ✓';
          toast.classList.add('is-visible');
          setTimeout(() => toast.classList.remove('is-visible'), 1200);
        }
        // Mise à jour du mini-counter si le thème écoute un event standard
        document.dispatchEvent(new CustomEvent('cart:update'));
      })
      .catch(() => {
        const band = btn.closest('[data-rf-size-band]');
        const toast = band && band.querySelector('.rf-size-band__toast');
        if (toast) {
          toast.textContent = 'Erreur…';
          toast.classList.add('is-visible');
          setTimeout(() => toast.classList.remove('is-visible'), 1200);
        }
      });
  }, true);
})();
